import { useQueryHook, useMutationHook } from 'utility/reactQueryHooks';

import DbSnapshotsApi from '../api/dbSnapshotsApi';

export const queryKeys = {
  list: (params) => ['dbSnapshots', JSON.stringify(params)],
  detail: (id) => ['dbSnapshots', 'detail', id],
  create: ['dbSnapshots', 'create'],
  download: ['dbSnapshots', 'download'],
  revoke: ['dbSnapshots', 'revoke'],
  retry: ['dbSnapshots', 'retry'],
};

export const useQueryMaskJobs = (params, options = {}) =>
  useQueryHook(queryKeys.list(params), () => DbSnapshotsApi.listMaskJobs(params), { staleTime: 30_000, ...options });

export const useQueryMaskJob = (id, options = {}) =>
  useQueryHook(queryKeys.detail(id), () => DbSnapshotsApi.getMaskJob(id), {
    enabled: !!id,
    staleTime: 30_000,
    ...options,
  });

export const useMutationCreateMaskJob = () => useMutationHook(queryKeys.create, DbSnapshotsApi.createMaskJob);

export const useMutationDownloadMaskJob = () => useMutationHook(queryKeys.download, DbSnapshotsApi.downloadMaskJob);

export const useMutationRevokeMaskJob = () => useMutationHook(queryKeys.revoke, DbSnapshotsApi.revokeMaskJob);

export const useMutationRetryMaskJob = () => useMutationHook(queryKeys.retry, DbSnapshotsApi.retryMaskJob);

export const useQueryTenantSearch = (query, options = {}) =>
  useQueryHook(['maskJobs', 'tenant-search', query], () => DbSnapshotsApi.searchTenants(query), {
    staleTime: 30_000,
    ...options,
  });
